import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getTourV2ExperienceItemsViews from 'checkout/selectors/view/itemViews/getTourV2ExperienceItemsViews'

const getCheckoutTourExperiencePointsCalculationRequests = createSelector(
  (state: App.State) => getTourV2ExperienceItemsViews(state),
  (tourExperienceItemView): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!tourExperienceItemView.hasRequiredData) return EmptyArray

    return tourExperienceItemView.data.map((itemView): App.LoyaltyDefaultPointsEarnCalculationRequest => {
      return {
        price: itemView.totals.price,
        loyaltyProductType: 'tour_optional_extra',
        itemId: itemView.item.itemId,
      }
    })
  },
)

export default getCheckoutTourExperiencePointsCalculationRequests
